<app-admin-page-model routeName="Labels" pageTitle="Gestion des labels">
  <button (click)="create()" class="btn btn-primary">
    <fa-icon icon="plus-circle"></fa-icon>&nbsp;Ajouter un label
  </button>

  <app-dynamic-modal-form
    [title]="toEdit?.id ? 'Modification de label' : 'Ajout d\'un label'"
    [generator]="labelFormGeneratorService"
    [actions]="[{label: 'Enregistrer', class: 'btn-primary', icon: 'save'}]"
    [object]="toEdit"
    (onSubmit)="save($event)">
    <ng-template let-form>
      <h2>Aperçu</h2>
      <app-badge [label]="form.getRawValue()"></app-badge>
      <h2>Contraste</h2>
      <app-color-contrast [color1]="form.getRawValue().textcolor"
                          [color2]="form.getRawValue().backcolor"></app-color-contrast>
    </ng-template>
  </app-dynamic-modal-form>

  <app-dynamic-modal-form
    title="Suppression du label"
    [actions]="[{label: 'Supprimer', class: 'btn-danger', icon: 'trash-alt'}]"
    [object]="toDelete"
    (onSubmit)="remove()">
    <ng-template let-object="object">
      <p>
        Êtes-vous sûr de vouloir supprimer le label
        <app-badge class="d-inline-block" [label]="object"></app-badge>
        ?
      </p>
    </ng-template>
  </app-dynamic-modal-form>


  <div class="mt-4">
    <ls-dynamic-table
      currentSort="name"
      sortAsc="false"
      [data]="labels | async"
      [actions]="tableActions"
      [headers]="tableaHeaders">
      <ng-template let-item>
        <td class="d-none d-md-table-cell">
          <app-badge [label]="item"/>
        </td>
        <th scope="row" class="d-table-cell d-md-none">
          <app-badge [label]="item"/>
        </th>
        <td class="d-none d-md-table-cell">
          {{item.name}}
        </td>
        <td>
          <span class="d-inline d-md-none">Couleur de fond : </span>
          {{item.backcolor}}
        </td>
        <td>
          <span class="d-inline d-md-none">Couleur de texte : </span>
          {{item.textcolor}}
        </td>
        <td>
          <span class="d-inline d-md-none">Accessibilité : </span>
          <app-color-contrast [color1]="item.textcolor" [color2]="item.backcolor"/>
        </td>
      </ng-template>
    </ls-dynamic-table>
  </div>

</app-admin-page-model>
